import { classNames } from "@punks/ui-core"
import Link from "next/link"
import { Locale } from "../../../../lib/i18n"
import { ensureLocalizedPath, useLocale } from "../../../../modules/navigation"

export interface AppLinkProps {
  href?: string
  target?: string
  blank?: boolean
  children: React.ReactNode
  onClick?: () => void
  className?: string
  locale?: Locale
}

const AppLink = ({
  href,
  blank,
  target,
  onClick,
  children,
  className,
  locale: propLocale,
}: AppLinkProps) => {
  // Get locale from context
  const { locale: contextLocale } = useLocale()
  
  // Allow override through props
  const currentLocale = propLocale || contextLocale
  
  if (!href) {
    return onClick ? (
      <div
        className={classNames("cursor-pointer", className)}
        onClick={onClick}
      >
        {children}
      </div>
    ) : (
      <>{children}</>
    )
  }

  // Use the ensureLocalizedPath function to get properly localized URL
  const localeHref = ensureLocalizedPath(href, currentLocale)

  return (
    <Link
      href={localeHref}
      target={target ?? (blank ? "_blank" : undefined)}
      onClick={onClick}
      className={className}
    >
      {children}
    </Link>
  )
}

export default AppLink
